import { AriaLiveTee } from 'components/common/AriaLive';
import { formatStockMessage } from 'components/productdetail/stylepicker/AddToCart';
import { getStockMessage } from 'components/productdetail/StockMessage/StockMessage.utility';
import { FEATURE_PDP_OOS_UX } from 'constants/features';
import { stringTemplate } from 'helpers/stringTemplate';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import useMartyContext from 'hooks/useMartyContext';
import { cn } from 'helpers/classnames';

export const StockMessage = (props: StockMessageProps) => {
  const { isEnrolled: isPdpOosUx } = useIsEnrolledInVariant({ featureFlag: FEATURE_PDP_OOS_UX, isZapposOnly: false });

  if (isPdpOosUx) {
    return <StockMessageTreatment {...props} />;
  }

  return <StockMessageControl {...props} />;
};

interface StockMessageProps {
  onHand: number;
}

export const StockMessageControl = (props: StockMessageProps) => {
  const { onHand } = props;
  const {
    marketplace: {
      is6pm,
      pdp: { lowStockMessage }
    },
    testId
  } = useMartyContext();

  if (onHand === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'mb-2',
        is6pm
          ? 'text-[#d34004]'
          : 'mx-auto text-[#b00020] zappos:w-fit zappos:rounded-sm zappos:px-3 zappos:py-1 zappos:font-medium zappos:text-red-350'
      )}
      data-test-id={testId('stockMessage')}
    >
      <AriaLiveTee>{formatStockMessage(stringTemplate(lowStockMessage, { onHand }))}</AriaLiveTee>
    </div>
  );
};

export const StockMessageTreatment = (props: StockMessageProps) => {
  const { onHand } = props;
  const {
    marketplace: {
      pdp: { lowStockMessage }
    },
    testId
  } = useMartyContext();

  return (
    <div
      className={cn(
        'w-fit rounded-full bg-alert px-3 py-1 font-medium text-link-highlight',
        'zappos:rounded-sm zappos:bg-red-50 zappos:font-medium zappos:text-red-350'
      )}
      data-test-id={testId('stockMessage')}
    >
      <AriaLiveTee>{getStockMessage({ onHand, lowStockMessage })}</AriaLiveTee>
    </div>
  );
};
